import React, { useCallback } from "react";
import { connect } from "react-redux";

import { faSave } from "@fortawesome/pro-solid-svg-icons/faSave";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Space from "antd/es/space";
import { useIntl } from "react-intl";

import { Button } from "@mapmycustomers/ui";

import { RootState } from "@app/store/rootReducer";

import { reportsExportsAnalytics } from "../../reportsAnalytics";
import { saveReport } from "../../store/actions";
import { canSaveReport, isSavingReport } from "../../store/selectors";

type Props = {
  className?: string;
} & ReturnType<typeof mapStateToProps> &
  typeof mapDispatchToProps;

const ReportActions = ({ canSaveReport, className, isSavingReport, saveReport }: Props) => {
  const intl = useIntl();

  const handleSaveClick = useCallback(() => {
    reportsExportsAnalytics.completed("Edit");
    saveReport();
  }, [saveReport]);

  return (
    <Space className={className} size="small">
      <Button
        disabled={!canSaveReport || isSavingReport}
        leftIcon={<FontAwesomeIcon icon={faSave} />}
        loading={isSavingReport}
        onClick={handleSaveClick}
        type="primary"
      >
        {intl.formatMessage({
          id: "reports.exports.save",
          defaultMessage: "Save & Exit",
          description: "Label of the Save Report button",
        })}
      </Button>
    </Space>
  );
};

const mapStateToProps = (state: RootState) => ({
  canSaveReport: canSaveReport(state),
  isSavingReport: isSavingReport(state),
});

const mapDispatchToProps = {
  saveReport: saveReport.request,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReportActions);
